// extracted by mini-css-extract-plugin
export var footer = "_n4-5";
export var fulfillmentInput = "_n4-0";
export var shipDateInput = "_n4-1";
export var shipmentModal = "_n4-2";
export var shipmentModalContent = "_n4-3";
export var tableContainer = "_n4-4";